// assets/js/mobile-nav.js

export function initMobileNav() {
  const panel = document.getElementById('mnav-panel');
  if (!panel) return;

  const body = document.documentElement;
  const closeBtns = panel.querySelectorAll('.js-mnav-close');
  const rootToggles = panel.querySelectorAll('.js-mnav-root');
  const backButtons = panel.querySelectorAll('.js-mnav-back');
  const lvl2Toggles = panel.querySelectorAll('.js-mnav-lvl2');

  // --- helpers ----------------------------------------------------------

  function openMenu() {
    panel.classList.remove('hidden');        // ⬅️ IMPORTANT
    panel.setAttribute('aria-hidden', 'false');
    body.classList.add('is-mnav-open');
  }

  function closeMenu() {
    panel.classList.add('hidden');           // ⬅️ IMPORTANT
    panel.setAttribute('aria-hidden', 'true');
    body.classList.remove('is-mnav-open');

    // reset all states
    panel.querySelectorAll('.m-nav__root-panel').forEach((rp) => {
      rp.classList.add('hidden');
      rp.classList.remove('is-showing-lvl3');
      rp.removeAttribute('data-lvl3-title');
    });
    panel.querySelectorAll('.m-nav__root').forEach((root) => {
      root.classList.remove('is-root-open');
    });
    panel.querySelectorAll('.m-nav__root-toggle').forEach((btn) => {
      btn.setAttribute('aria-expanded', 'false');
    });
    panel.querySelectorAll('.m-nav__lvl2-item').forEach((item) => {
      item.classList.remove('is-lvl3-current');
    });
    panel.querySelectorAll('.js-mnav-lvl3').forEach((lvl3) => {
      lvl3.classList.add('hidden');
    });

    // restaurer les titres root
    panel.querySelectorAll('.m-nav__root-panel').forEach((rp) => {
      const title = rp.dataset.rootTitle;
      const titleEl = rp.querySelector('.m-nav__section-title');
      if (title && titleEl) {
        titleEl.textContent = title;
      }
    });
  }

  function closeAllRootPanels(except) {
    panel.querySelectorAll('.m-nav__root-panel').forEach((rp) => {
      if (rp === except) return;
      rp.classList.add('hidden');
      rp.classList.remove('is-showing-lvl3');
      rp.removeAttribute('data-lvl3-title');
      const li = rp.closest('.m-nav__root');
      if (li) li.classList.remove('is-root-open');
    });
    panel.querySelectorAll('.m-nav__root-toggle').forEach((btn) => {
      if (except && btn.closest('.m-nav__root') === except.closest('.m-nav__root')) return;
      btn.setAttribute('aria-expanded', 'false');
    });
  }

  // --- open / close depuis le bouton header -----------------------------

  const toggleHeaderBtn = document.querySelector('.js-mnav-toggle');
  if (toggleHeaderBtn) {
    toggleHeaderBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const isOpen = body.classList.contains('is-mnav-open');
      if (isOpen) {
        closeMenu();
      } else {
        openMenu();
      }
    });
  }

  closeBtns.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      closeMenu();
    });
  });

  // --- niveau ROOT ------------------------------------------------------

  rootToggles.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();

      const rootLi = btn.closest('.m-nav__root');
      const rootPanel = rootLi.querySelector('.js-mnav-root-panel');
      if (!rootPanel) return;

      const isExpanded = btn.getAttribute('aria-expanded') === 'true';

      if (isExpanded) {
        // on referme
        btn.setAttribute('aria-expanded', 'false');
        rootPanel.classList.add('hidden');
        rootLi.classList.remove('is-root-open');
      } else {
        // on ouvre ce root
        closeAllRootPanels(rootPanel);
        btn.setAttribute('aria-expanded', 'true');
        rootPanel.classList.remove('hidden');
        rootLi.classList.add('is-root-open');
      }
    });
  });

  // --- BACK button (root / lvl3) ---------------------------------------

  backButtons.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const rootPanel = btn.closest('.js-mnav-root-panel');
      if (!rootPanel) return;

      const rootLi = rootPanel.closest('.m-nav__root');
      const headerTitle = rootPanel.querySelector('.m-nav__section-title');

      // cas 1 : on est dans un lvl3 (marques)
      if (rootPanel.classList.contains('is-showing-lvl3')) {
        rootPanel.classList.remove('is-showing-lvl3');

        // restaurer le titre root
        const rootTitle = rootPanel.dataset.rootTitle;
        if (rootTitle && headerTitle) headerTitle.textContent = rootTitle;

        // réafficher tous les lvl2 + recacher les lvl3
        rootPanel.querySelectorAll('.m-nav__lvl2-item').forEach((item) => {
          item.classList.remove('is-lvl3-current');
        });
        rootPanel.querySelectorAll('.js-mnav-lvl3').forEach((lvl3) => {
          lvl3.classList.add('hidden');
        });

        return; // on reste dans ce root
      }

      // cas 2 : retour au niveau racine
      rootPanel.classList.add('hidden');
      if (rootLi) {
        rootLi.classList.remove('is-root-open');
        const toggle = rootLi.querySelector('.m-nav__root-toggle');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      }
    });
  });

  // --- LVL2 -> LVL3 (marques) ------------------------------------------

  lvl2Toggles.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();

      const rootPanel = btn.closest('.js-mnav-root-panel');
      if (!rootPanel) return;

      const lvl2Item = btn.closest('.m-nav__lvl2-item');
      if (!lvl2Item) return;

      const lvl3 = lvl2Item.querySelector('.js-mnav-lvl3');
      if (!lvl3) return;

      const headerTitle = rootPanel.querySelector('.m-nav__section-title');
      const lvl2Link = lvl2Item.querySelector('.m-nav__lvl2-link');
      const lvl2Title = lvl2Link ? lvl2Link.textContent.trim() : '';

      // titre du lvl3 dans le header
      if (lvl2Title && headerTitle) {
        headerTitle.textContent = lvl2Title;
      }

      // flag pour le back
      rootPanel.classList.add('is-showing-lvl3');
      rootPanel.dataset.lvl3Title = lvl2Title;

      // cacher tous les lvl2 + lvl3
      rootPanel.querySelectorAll('.m-nav__lvl2-item').forEach((item) => {
        item.classList.remove('is-lvl3-current');
      });
      rootPanel.querySelectorAll('.js-mnav-lvl3').forEach((block) => {
        block.classList.add('hidden');
      });

      // ne garder que ce lvl2 comme "contenant" du lvl3
      lvl2Item.classList.add('is-lvl3-current');
      lvl3.classList.remove('hidden');
    });
  });
}
